function getUrlSeparator(url = "") {
  return url.indexOf("?") === -1 ? "?" : "&";
}

export default getUrlSeparator;



// WEBPACK FOOTER //
// ./utils/getUrlSeparator.js